import { AfterContentInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
	selector: '[scrollIntoView]',
})
export class ScrollIntoViewDirective {
	@Input() public scrollIntoView: boolean;
	@Input() public onlyWhenHidden: boolean;

	public constructor(private el: ElementRef) {}

	ngOnChanges() {
		if (this.scrollIntoView) {
			if (this.onlyWhenHidden) {
				this.isVisible();
			} else {
				this.el.nativeElement.scrollIntoView();
			}
		}
	}

	isVisible() {
		var hijo = this.el.nativeElement;
		var papa = this.el.nativeElement.parentElement.parentElement;
		var hijo_rect = hijo.getBoundingClientRect();
		var papa_rect = papa.getBoundingClientRect();
		var htop = hijo.offsetTop + hijo_rect.height;
		var htop2 = hijo.offsetTop;
		var pp = papa.scrollTop + papa.getBoundingClientRect().height;
		if (htop < pp) {
		} else if (htop > pp) {
			this.el.nativeElement.scrollIntoView(false);
		}
		if (papa.scrollTop > hijo.offsetTop) {
			this.el.nativeElement.scrollIntoView();
		}
		return;
	}
}
